import styled from "styled-components";
import { Modal, Steps, List, Card, Space, Form, Divider, InputNumber, Typography } from "antd";

export const StyledDHSCheckInsuranceContainer = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
    margin-bottom: 24px;

  .dhs-checkinsurance-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    align-items: center;
    
    @media (max-width: 576px) {
      flex-direction: column;
      align-items: stretch;
      
      button {
        width: 100%;
      }
    }
  }

  .dhs-checkinsurance-summary {
    margin-top: 0.25rem;
    display: block;
    font-size: 0.875rem;
  }
`;

export const StyledInsuranceModal = styled(Modal)`
  top: 0;
  max-width: 100vw;
  margin: 0;
  padding: 0;
  width: 100% !important;

  @media (min-width: 768px) {
    top: 50px;
    max-width: 800px;
    width: 80% !important;
    margin: 0 auto;
    padding-bottom: 0;
  }

  .ant-modal-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    
    @media (min-width: 768px) {
      height: auto;
      max-height: 90vh;
      border-radius: 8px;
    }
  }

  .ant-modal-header {
    flex-shrink: 0;
    padding: 1rem 1.5rem;
    border-radius: 0;
    
    @media (min-width: 768px) {
      border-radius: 8px 8px 0 0;
    }
  }

  .ant-modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 1rem 1.5rem;
    
    /* Ensure content doesn't get cut off on mobile */
    @media (max-width: 767px) {
      padding: 1rem;
    }
  }

  .ant-modal-footer {
    flex-shrink: 0;
    padding: 1rem 1.5rem;
    border-top: 1px solid #f0f0f0;
    
    @media (max-width: 767px) {
      padding: 1rem;
    }
  }
`;

export const StyledSteps = styled(Steps)`
  margin-bottom: 1.5rem;
  width: 100%;
  overflow: hidden; /* Prevent horizontal scroll if steps are too wide */
  
  @media (min-width: 768px) {
    padding: 0 1rem;
  }

  .ant-steps-item {
    /* Improve step item spacing */
    padding-left: 0 !important; 
  }
  
  .ant-steps-item-title {
    font-size: 0.875rem;
    line-height: 1.2;
    white-space: normal; /* Allow title wrapping */
  }

  /* Vertical steps on mobile */
  &.ant-steps-vertical {
    .ant-steps-item {
      overflow: visible;
    }
    
    .ant-steps-item-container {
      display: flex;
      align-items: flex-start;
    }
    
    .ant-steps-item-content {
      min-height: auto; /* Allow content height to adapt */
      padding-bottom: 1rem;
    }
  }
`;

export const StyledStepContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledRadioList = styled(List)`
  width: 100%;
  
  .ant-list-item {
    padding: 0.5rem 0;
    border-bottom: none !important; /* Remove default border if needed */
  }
  
  .ant-radio-wrapper {
    width: 100%;
    white-space: normal; /* Allow radio label to wrap */
    margin-right: 0;
    align-items: flex-start; /* Align radio button to top */
    
    span.ant-radio + * {
      width: 100%; /* Ensure content takes full width */
    }
  }
`;

export const StyledInsuranceCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-top: 0.75rem; /* Add consistent margin top */
  
  .ant-card-head {
    min-height: auto;
    padding: 0.75rem 1rem;
    
    .ant-card-head-title {
      white-space: normal;
      font-size: 0.9rem;
      padding: 0;
      line-height: 1.4;
    }
    
    .ant-card-extra {
      padding: 0;
      font-size: 0.8rem;
    }
  }
  
  .ant-card-body {
    padding: 0.75rem 1rem;
  }

  /* Make descriptions responsive inside card */
  .ant-descriptions-item-label {
    font-weight: 500;
    color: #8c8c8c;
  }
  
  .ant-descriptions-item-content {
    font-weight: 400;
  }
  
  @media (max-width: 576px) {
    .ant-card-head {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
      
      .ant-card-extra {
        margin-left: 0;
        color: #8c8c8c;
      }
    }
  }
`;

export const StyledFooterSpace = styled(Space)`
  width: 100%;
  justify-content: flex-end;
  
  @media (max-width: 576px) {
    flex-direction: column-reverse; /* Put primary button on top if stacked */
    width: 100%;
    gap: 0.75rem;
    
    .ant-space-item {
      width: 100%;
    }
    
    button {
      width: 100%;
    }
  }
`;

export const StyledForm = styled(Form)`
  margin-top: 1rem;
  width: 100%;
  
  .ant-form-item {
    margin-bottom: 1rem;
  }
  
  .ant-form-item-label {
    padding-bottom: 0.25rem;
    
    label {
      font-size: 0.875rem;
    }
  }
`;

export const StyledCheckboxContainer = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  
  .ant-checkbox-wrapper {
    white-space: normal;
    align-items: flex-start;
    line-height: 1.4;
    
    span + span {
      padding-top: 2px; /* Align text with checkbox */
    }
  }
`;

export const StyledActionButtons = styled(Space)`
  margin-top: 1rem;
  width: 100%;
  flex-wrap: wrap;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    
    .ant-space-item {
      width: 100%;
    }
    
    button {
      width: 100%;
    }
  }
`;

export const StyledTwoColumnContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  width: 100%;
  
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0; /* Form items have their own margin */
  }
  
  > div {
    flex: 1;
    width: 100%; /* Ensure full width inside flex item */
    min-width: 0; /* Prevent flex overflow */
  }
`;

export const StyledInlineFormItem = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  
  /* On very small screens, keep inline but maybe adjust spacing */
  @media (max-width: 400px) {
    gap: 0.25rem;
  }
  
  .ant-form-item {
    flex: 1;
    margin-bottom: 0;
  }
  
  /* The checkbox or suffix element */
  > .ant-form-item:last-child {
    flex: 0 0 auto;
    margin-left: auto;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 1rem 0 !important;
`;

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
`;

export const StyledCompactFormItem = styled(Form.Item)`
  margin-bottom: 0 !important;
`;

export const StyledHelpText = styled(Typography.Text)`
  font-size: 0.75rem !important;
`;

export const StyledVerticalSpace = styled(Space)`
  width: 100%;
`;

export const StyledDHSCheckInsuranceLoadingContainer = styled.div`
  padding: 24px;
  background: #fff;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
